import { Box, TableCell } from "@mui/material";
import StyledTableRow from "../../../../components/table/styled-table-row";
import { useState } from "react";
import { ConfirmationDialog } from "../../../../components/confiramation-dialog";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { selectLoggedInUser } from "../../../auth/auth.slice";
import TableActionButton from "../../../../components/table/table-action-button";
import { EditIcon, DeleteIcon } from "../../../../shared/icons";
import { Exercise, ExerciseRequest } from "../../../../service/model/workout.model";
import { deleteExercise, updateExercise } from "../exercise.slice";
import ExerciseForm from "../../workout-plan/components/exercise-form";
import { UserType } from "../../../../shared/enums";

interface TableRowProps {
    readonly exercise: Exercise
}

const ExerciseTableRow: React.FC<TableRowProps> = ({ exercise }) => {
    const dispatch = useAppDispatch();
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const [showMembershipForm, setShowMembershipForm] = useState(false);
    const loggedInUserDetails = useAppSelector(selectLoggedInUser);
    const loggedInUser = loggedInUserDetails?.user;

    const handleDelete = () => {
        dispatch(deleteExercise(exercise.id))
        setShowDeleteDialog(false)
    }

    const handleDeleteCancel = () => {
        setShowDeleteDialog(false)
    }

    const handleSubmit = (data: ExerciseRequest) => {
        loggedInUser && dispatch(updateExercise({ ...data, id: exercise.id })).then(resp => {
            if (resp.meta.requestStatus === 'fulfilled') {
                setShowMembershipForm(false);
            }
        });
    };


    const isAuthorizedUser = () => {
        if (!exercise.isGlobal) {
            if(loggedInUserDetails?.type === UserType.MEMBER) {
                return loggedInUserDetails?.roleData?.member?.id && exercise.memberId === loggedInUserDetails?.roleData?.member?.id;
            } else if(loggedInUserDetails?.type === UserType.BUSINESS_USER) {
                return loggedInUserDetails?.roleData?.businessUser?.business?.id && exercise.businessId === loggedInUserDetails?.roleData?.businessUser?.business?.id;
            }
        }
        return false;
    }

    const editable = isAuthorizedUser();

    return (
        <>
            <StyledTableRow key={exercise.id}>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Name</Box>{exercise.name}</TableCell>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Muscle Group</Box>{exercise.muscleGroup}</TableCell>
                {/* <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Equipment</Box>{exercise.equipment}</TableCell> */}
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Description</Box>{exercise.description}</TableCell>
                <TableCell>
                    <Box component="div" display="inline" className="responsive-mobile-heading">Actions</Box>
                    <TableActionButton onClick={() => setShowMembershipForm(true)} label="Edit" icon={<EditIcon />} disabled={!editable} />
                    <TableActionButton onClick={() => setShowDeleteDialog(true)} label="Delete" icon={<DeleteIcon />} disabled={!editable} />
                </TableCell>
            </StyledTableRow>
            {showMembershipForm &&
                <ExerciseForm exercise={exercise} editable={true} onClose={() => setShowMembershipForm(false)} onSubmit={handleSubmit} />
            }
            {showDeleteDialog &&
                <ConfirmationDialog show={true} message="Are you sure you want to delete?" onConfirm={handleDelete} onCancel={handleDeleteCancel} />
            }
        </>
    );
}

export default ExerciseTableRow;